import React from 'react';
import { ArrowRight } from 'lucide-react';
export function CTASection() {
  return <section className="w-full py-24 px-4 bg-sage/10" data-id="element-10">
      <div className="max-w-3xl mx-auto text-center" data-id="element-11">
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-brown mb-6 leading-tight" data-id="element-12">
          Recuperá tu ropa. <br data-id="element-13" />
          Recuperá tus ganas. <br data-id="element-14" />
          <span className="text-terracotta" data-id="element-15">Recuperá tu cuerpo.</span>
        </h2>

        <p className="text-xl text-brown-light font-body mb-10" data-id="element-16">
          Hoy podés acceder al protocolo completo por un precio de lanzamiento
          exclusivo para Argentina.
        </p>

        <div className="bg-white p-8 rounded-2xl shadow-lg max-w-xl mx-auto border border-sage/20" data-id="element-17">
          <div className="flex justify-center mb-6" data-id="element-18">
            <img src="https://cdn.magicpatterns.com/uploads/95UPB9PoGkp88KAazRSLWd/heylloyd-image-1771418442528.png" alt="Protocolo Vientre Plano & Energía 30-70" className="w-full max-w-xs rounded-lg" data-id="element-19" />
          </div>

          <div className="mb-8" data-id="element-20">
            <span className="text-sm text-gray-500 uppercase tracking-wider font-bold" data-id="element-21">
              Precio de Lanzamiento
            </span>
            <div className="flex items-center justify-center mt-2" data-id="element-22">
              <span className="text-4xl md:text-5xl font-bold text-brown font-heading" data-id="element-23">
                AR$ 9.300
              </span>
            </div>
            <p className="text-sm text-gray-500 mt-2" data-id="element-24">
              (Pago único por Mercado Pago)
            </p>
          </div>

          <a href="https://argrutinas.com/cart/42975947358417:1" target="_blank" rel="noopener noreferrer" onClick={() => {
          if (window.fbq) {
            window.fbq('track', 'AddToCart', {
              content_name: 'Protocolo Vientre Plano & Energía 30-70',
              content_type: 'product',
              value: 9300,
              currency: 'ARS'
            });
          }
        }} className="w-full bg-sage hover:bg-sage-dark text-white font-bold py-4 px-8 rounded-lg text-lg transition-all transform hover:scale-[1.02] shadow-md flex items-center justify-center group no-underline" data-id="element-25">
            <span data-id="element-26">QUIERO EL PROTOCOLO POR SÓLO AR$ 9.300</span>
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-27" />
          </a>
        </div>
      </div>
    </section>;
}